import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import Spinner from 'components/spinner';
import { computed } from 'mobx';

const Wrapper = styled.div`
  background: white;
  border-radius: 10px;
  width: 100%;
  padding: 20px;
  a {
    text-decoration: underline;
  }
`;

@observer
class GroupInfo extends React.Component {
  constructor(props) {
    super(props);
  }

  @computed get content() {
    return AppUI.pageStore.indexData?.find(page => page.slug === this.props.params.pageId)?.content;
  }

  render() {
    return (
      <Wrapper>
        {
          AppUI.pageStore.hasOutstandingRequests
            ? <Spinner />
            : <div
              dangerouslySetInnerHTML={{ __html: this.content }}
            />
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(GroupInfo);
